export default {
  FAMILY: "Familie",
  AGENCY: "Maatschappij",
  USER: "Gebruiker",
  OFFICE: "Kantoor",
  DAMAGE: "Schade",
  MORTGAGE: "Hypotheek",
};
